(function () {
  const presentationBoxes = {
    'black cardboard box': [
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-black-cardboard-box-01.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-black-cardboard-box-02.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-black-cardboard-box-03.jpg'
    ],

    'black, lined, form-fit': [
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-black-lined-form-fit-01.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-black-lined-form-fit-02.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-black-lined-form-fit-03.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-black-lined-form-fit-04.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-black-lined-form-fit-05.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-black-lined-form-fit-06.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-black-lined-form-fit-07.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-black-lined-form-fit-08.jpg'
    ],

    'blue, lined, form-fit': [
        'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-blue-lined-form-fit-01.jpg',
        'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-blue-lined-form-fit-02.jpg',
        'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-blue-lined-form-fit-03.jpg',
        'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-blue-lined-form-fit-04.jpg',
        'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-blue-lined-form-fit-05.jpg'
    ],

    'blue velvet, lined, form-fit': [
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-blue-velvet-lined-form-fit-01.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-blue-velvet-lined-form-fit-02.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-blue-velvet-lined-form-fit-03.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-blue-velvet-lined-form-fit-04.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-blue-velvet-lined-form-fit-05.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-blue-velvet-lined-form-fit-06.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-blue-velvet-lined-form-fit-07.jpg'
    ],

    'kraft cardboard': [
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-kraft-cardboard-01.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-kraft-cardboard-02.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-kraft-cardboard-03.jpg'
    ],

    'kraft envelope': [
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-kraft-envelope.jpg'
    ],

    'patterned cardboard': [
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-patterned-cardboard-01.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-patterned-cardboard-02.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-patterned-cardboard-03.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-patterned-cardboard-04.jpg'
    ],

    'red, lined, form-fit': [
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-red-lined-form-fit-01.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-red-lined-form-fit-02.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-red-lined-form-fit-03.jpg'
    ],

    'silver, lined, form-fit': [
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-silver-lined-form-fit-01.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-silver-lined-form-fit-02.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-silver-lined-form-fit-03.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-silver-lined-form-fit-04.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-silver-lined-form-fit-05.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-silver-lined-form-fit-06.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-silver-lined-form-fit-07.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-silver-lined-form-fit-08.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-silver-lined-form-fit-09.jpg'
    ],

    'white cardboard': [
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-white-cardboard-01.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-white-cardboard-02.jpg',
      'https://cdn.shopify.com/s/files/1/0759/0330/3970/files/presentation-white-cardboard-03.jpg'
    ]
  };


  const headingSelector = 'h1, h2, h3, h4, h5, h6';
  const legacyAssetPattern = /\/t\/11\/assets\//i;


  function normalizeText(text) {
    return (text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }


  function isLegacyAmpImage(img) {
    const possibleSources = [
      img.getAttribute('src'),
      img.getAttribute('srcset'),
      img.getAttribute('data-src'),
      img.getAttribute('data-srcset'),
      img.getAttribute('data-lazy-src'),
      img.getAttribute('data-lazy-srcset'),
      img.currentSrc
    ];

    return possibleSources.some(function (source) {
      return source && legacyAssetPattern.test(source);
    });
  }


  function replaceImage(img, newUrl) {
    /*
     * Remove old responsive/lazy-load URLs first so the browser
     * cannot choose the deleted theme asset instead of our new src.
     */
    img.removeAttribute('srcset');
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-lazy-src');
    img.removeAttribute('data-lazy-srcset');

    img.src = newUrl;
  }


  function fixPresentationBoxImages() {
    /*
     * Get headings and images in the exact order they appear
     * in the document.
     */
    const elements = Array.from(
      document.querySelectorAll(
        'h1, h2, h3, h4, h5, h6, img'
      )
    );

    elements.forEach(function (element, elementIndex) {
      if (!element.matches(headingSelector)) {
        return;
      }

      const boxName = normalizeText(element.textContent);
      const replacementImages = presentationBoxes[boxName];

      /*
       * This heading isn't one of our ten presentation boxes.
       */
      if (!replacementImages) {
        return;
      }

      let imagePosition = 0;

      /*
       * Starting immediately after the presentation-box heading,
       * walk forward until we hit the next heading.
       *
       * Every image encountered gets a positional number:
       * 0 = image 01
       * 1 = image 02
       * etc.
       */
      for (
        let i = elementIndex + 1;
        i < elements.length;
        i++
      ) {
        const nextElement = elements[i];

        /*
         * The next heading marks the end of this presentation-box
         * section.
         */
        if (nextElement.matches(headingSelector)) {
          break;
        }

        if (nextElement.tagName !== 'IMG') {
          continue;
        }

        const replacementUrl =
          replacementImages[imagePosition];

        /*
         * Only replace images belonging to the deleted AMP
         * asset theme.
         *
         * Newer /cdn/shop/files/ images are left untouched.
         */
        if (
          replacementUrl &&
          isLegacyAmpImage(nextElement)
        ) {
          replaceImage(nextElement, replacementUrl);
        }

        /*
         * Increment even if this particular image was already
         * repaired. This preserves its correct position within
         * the presentation-box image sequence.
         */
        imagePosition++;
      }
    });
  }


  /*
   * AMP's content is already present in the server-rendered HTML
   * on the current store, but DOMContentLoaded keeps this safe
   * if script placement changes later.
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      fixPresentationBoxImages
    );
  } else {
    fixPresentationBoxImages();
  }
})();